import Axios from 'axios';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { errorCatch } from './errorCatcher.reducer';
import { saveSpecialPriceData } from './companyData.reducer';

export type InitState = {
  specialPriceClient: {
    status: string;
    data: SpecialPriceClient;
  };
  specialPriceId: string;
};

export const initialState = {
  specialPriceClient: {
    status: '',
    data: {
      companyId: 0,
      companyName: '',
      aionOrganizationId: '',
      sku: '',
      isUsed: null
    }
  },
  specialPriceId: ''
} as InitState;

export type SpecialPriceClient = {
  companyId: number;
  companyName: string;
  aionOrganizationId: string;
  sku: string;
  isUsed: boolean | null;
};

export const getSpecialPriceClient = createAsyncThunk(
  'specialPrice/getSpecialPriceClient',
  async (recordId: string, { dispatch }) => {
    try {
      const { data } = await Axios.get(`/api/v1/billing/company/${recordId}/specialpricing`);
      dispatch(saveSpecialPriceData({ sku: data.sku, specialPricingId: recordId }));

      return data;
    } catch (error) {
      dispatch(errorCatch({ place: 'specialPrice/getSpecialPriceClient.rejected', data: error }));
      return Promise.reject(error);
    }
  }
);

const slice = createSlice({
  name: 'specialPrice',
  initialState,
  reducers: {},
  extraReducers: {
    [getSpecialPriceClient.pending.toString()]: state => {
      state.specialPriceClient.status = 'loading';
    },
    [getSpecialPriceClient.fulfilled.toString()]: (state, action) => {
      state.specialPriceClient.data = action.payload;
      state.specialPriceClient.status = 'success';
    },
    [getSpecialPriceClient.rejected.toString()]: state => {
      state.specialPriceClient.status = 'rejected';
    }
  }
});

export default slice.reducer;
